import * as React from "react";
import { AgGridReact } from "ag-grid-react";
import { useState, useEffect } from "react";
import {
  DownloadDocument,
  getInvestorActivities,
  getActivities
} from "../../config/apiConfig";
import { sbaAxios } from "../utils/sbaAxios";
import { SBNotify } from "../utils/sbNotify";
import { getDocbyActivityId } from "../../config/apiConfig";
import { WidgetCollectionContext } from "./home";
import { useContext } from "react";
import CloseSVG from "../../Images/close_svg.svg";

const RecentActivities = () => {
  const [gridData, setgridData] = useState([]);
  const [bIndex,setBIndex]=useState(0);

  const { removeWidget , toCustomize } = useContext(WidgetCollectionContext);
  const fetchInvestorActivities = async () => {
    try {
      const list = await sbaAxios({
        url: getInvestorActivities,
        params: {
          contactId: -1,
          accountIds: -1,
          activiyTypeIds: -1,
          startDate: new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1).toISOString(),
          endDate: new Date().toISOString(),
          activitySubTypeIds: -1,
          subject: ""
        }
      });
      setgridData(list);
    }
    catch (e) {
      setgridData([]);
    }
  };

  const fetchInvestmentActivities = async () => {
    try {
      const list = await sbaAxios({
        url: getActivities,
        params: {
          EntityTypeName: "",
          EntityName: "",
          activitySourceId: 1,
          EntityTypeIds: -1,
          EntityId: "",
          ActiviyTypeIds: -1,
          StartDate: new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1).toISOString(),
          EndDate: new Date().toISOString(),
          ActivitySubTypeIds: -1,
          Subject: "",
          UserId: ""
        }
      });
      setgridData(list);
    }
    catch (e) {
      setgridData([]);
    }
  };

  useEffect(() => {
    if (bIndex === 0) {
      fetchInvestorActivities();
    }
    else if (bIndex === 1) {
      fetchInvestmentActivities();
    }
  }, [bIndex])

  const investorColDef = [
    { headerName: "Entity Type Name", field: "EntityTypeName" },
    { headerName: "Entity Name", field: "EntityName" },
    {
      headerName: "Document Date",
      field: "ActivityDate",
      valueFormatter: (params) => {
        const date = new Date(params.value);
        return `${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')}/${date.getFullYear()}`;
      },
    },
    { headerName: "Document Type", field: "ActivitySubType" },
    { headerName: "", field: "", maxWidth: 100, tooltipField: '', cellRenderer: ActionColumnCellRenderer },
  ];
  const investmentColDef = [
    { headerName: "Asset Name", field: "AssetName" },
    {
      headerName: "Activity Date",
      field: "ActivityDate",
      valueFormatter: (params) => {
        const date = new Date(params.value);
        return `${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')}/${date.getFullYear()}`;
      },
    },
    { headerName: "Activity Type", field: "ActivityType" },
    { headerName: "Activity Sub type", field: "ActivitySubType" },
    { headerName: "Activity Name", field: "ActivityName" },
    { headerName: "No. of Attach.", field: "NumOfAttachements", tooltipComponent: ToolTip, tooltipField: "NumOfAttachements" , maxWidth:50 ,   cellStyle: {cursor:'pointer'} , cellRenderer:(props)=>{return <>{props?.data?.NumOfAttachements>0 && <a title="View Attachments">{props?.data?.NumOfAttachements}</a>}</>}},

    //{headerName:"",field:"" , maxWidth:100, cellRenderer:ActionColumnCellRenderer},
  ];
  const defColDef = { flex: 1, resizable:true };
  const RecentActivitiesButtons = ['Investor', 'Investment'];
  const raButtonClick = (index) => {
    setBIndex(index);
  }
  return <>
      <div className="k-tilelayout-item k-card k-cursor-grab h-100">
  <div className="k-tilelayout-item-header k-card-header">
  <div className="header-container"><b> Recent Activities </b>
          <div className="button-container ms-auto">
            {RecentActivitiesButtons.map((name, index) => (
              <button
                key={index}
                className={bIndex === index ? "selected-non-gappable-button p-2" : "non-gappable-button p-2"}
                onClick={() => raButtonClick(index)}>
                {name}
              </button>
            ))}
          </div>
          {toCustomize && <a className="" href="#" onClick={() => {
           removeWidget(5)
        }}>
          <img src={CloseSVG}
            alt="close" />
    </a>}
        </div>
  </div>
  <div className="k-tilelayout-item-body k-card-body">
   {gridData.length>0 && <div className="ag-theme-alpine" style={{ pointerEvents: 'auto' }}>
      <AgGridReact
        rowData={gridData}
        columnDefs={bIndex === 0 ? investorColDef : investmentColDef}
        defaultColDef={defColDef}
        tooltipInteraction={true}
        tooltipShowDelay={0}
      ></AgGridReact>
    </div>
    }</div></div>
  </>
};

const reportdownload = (params) => {
  const documentId = params.data.DocumentId;
  const urlBuild = DownloadDocument + btoa(documentId.toString());
  sbaAxios({ url: urlBuild }).then((response) => {
    window.open(urlBuild);
  });
};

const ActionColumnCellRenderer = (params) => {

  if (!params.data.DocumentId) {
    return null;
  }

  return (
    <>
      <div className="pdf-icon-wrapper">
        <i
          className="far fa-file-pdf text-danger SBA_hand"
        onClick={() => {
          reportdownload(params);
        }}
        />
      </div>
    </>
  );
};

const ToolTip = (props) => {
  const [rowData, setRowData] = useState([]);
  useEffect(() => {
    sbaAxios({ url: getDocbyActivityId + props.data.ActivityId }).then(res => { setRowData(res) })
  }, [props]);
  const colDef = [
    { field: 'DocumentName', headerName: 'Document Name', },
    { field: '', cellRenderer: FileDownloadComponent , maxWidth:75},
  ]
  return <div className="ag-theme-alpine" style={{ width: '400px', pointerEvents: 'auto', height: '500px' }}>
    <AgGridReact
      rowData={rowData}
      columnDefs={colDef}
      defaultColDef={{ flex: 1,resizable:true }}
    ></AgGridReact>
  </div>
};
const FileDownloadComponent = (props) => {
  const item = props.data;
  let content;
  const pdfview = (documentId, documentExtension, documentName) => {
    try {
      documentExtension = documentExtension.toLowerCase();
      if (
        documentExtension === ".pdf" ||
        documentExtension === ".xlsx" ||
        documentExtension === ".xls" ||
        documentExtension === ".png" ||
        documentExtension === ".jpg" ||
        documentExtension === ".jpeg" ||
        documentExtension === ".gif" ||
        documentExtension === ".doc" ||
        documentExtension === ".docx" ||
        documentExtension === ".ppt" ||
        documentExtension === ".pptx" ||

        documentExtension === "pdf" ||
        documentExtension === "xlsx" ||
        documentExtension === "xls" ||
        documentExtension === "png" ||
        documentExtension === "jpg" ||
        documentExtension === "jpeg" ||
        documentExtension === "gif" ||
        documentExtension === "doc" ||
        documentExtension === "docx" ||
        documentExtension === "ppt" ||
        documentExtension === "pptx"
      ) {
        const encodedDocumentId = btoa(documentId.toString());
        const urls = DownloadDocument + encodedDocumentId;
        sbaAxios({
          url: urls,
        }).then((response) => {
          window.open(urls);

        });
      }

      else {
        const encodedDocumentId = btoa(documentId.toString());
        const urls = DownloadDocument + encodedDocumentId;
        sbaAxios({
          url: urls,
          responseType: 'blob'
        }).then((response) => {
          const blob = new Blob([response]);
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement('a');
          a.href = url;
          a.download = `${documentName}.${documentExtension}`
          document.body.appendChild(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);

        });
      }

    } catch (error) {
      console.error("Error opening document:", error);
    }
  };
  switch (item?.DocumentExtension.toLowerCase()) {
    case 'pdf':
    case '.pdf':
      content = <i
        class="fas fa-file-pdf"
        style={{ color: "#F40F02" }}
        onClick={() =>
          pdfview(
            item.DocumentId,
            item.DocumentExtension
          )

        }
      ></i>;
      break;
    default:
      content = <i
        class="fas fa-file-excel"
        style={{ color: "#1D6F42" }}
        onClick={() =>
          pdfview(
            item.DocumentId,
            item.DocumentExtension
          )
        }
      ></i>;
      break;
  }

  return <>{content}</>;
};


export default RecentActivities;


